import { PropsWithChildren, useEffect, useMemo, useState } from 'react';
import { IntlProvider } from 'react-intl';

import {
  DEFAULT_LOCALE,
  DEFAULT_MESSAGES,
  Messages,
  TranslationContext,
} from './TranslationContext';

interface I18nProviderProps extends PropsWithChildren {
  locale?: string;
}

export function I18nProvider({ children, locale: localeProp }: I18nProviderProps) {
  const [locale, setLocale] = useState(DEFAULT_LOCALE);
  const [messages, setMessages] = useState<Messages>(DEFAULT_MESSAGES);

  useEffect(() => {
    if (!localeProp || localeProp === DEFAULT_LOCALE) return;

    import(`../../lang/${localeProp}.json`)
      .then((mod) => {
        setLocale(localeProp);
        setMessages({ ...DEFAULT_MESSAGES, ...mod.default });
      })
      .catch(() => {
        // Translation file doesn't exist — stay on default locale
      });
  }, [localeProp]);

  const value = useMemo(
    () => ({ locale, messages }),
    [locale, messages]
  );

  return (
    <TranslationContext.Provider value={value}>
      <IntlProvider locale={locale} messages={messages}>
        {children}
      </IntlProvider>
    </TranslationContext.Provider>
  );
}
